<div
    class="d-flex w-100 h-100"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="d-flex w-100 pulse-yourteam"
        variant="colored"
        [collapsable]="false"
        (collapsedChange)="_collapsed = $event"
    >
        <cmps-container-header
            [separator]="false"
            [headerColour]="_widget?.headerColour"
            [textColour]="_widget?.headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content class="h-100">
            <div
                *ngIf="_data?.roster == null || _data?.roster?.length === 0"
                class="no-data h-100 d-flex align-items-center"
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>

            <div
                ngGrid
                [rendererOptions]="_gridData?.rendererOpts"
                [selectTemplate]="_gridData?.selectTpl"
                [rows]="_gridData?.rows"
                [sortDefs]="_gridData?.sortDefs"
                (willInflate)="_onWillInflate()"
                (didInflate)="_onDidInflate()"
                *ngIf="_data?.roster != null && _data?.roster?.length !== 0"
            >
                <ng-template
                    gridContent
                    data-type="grid"
                >
                    <div></div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="row"
                    data-id="header"
                >
                    <div class="yourteam-header"></div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="cell"
                    data-id="header"
                    let-ctx="ctx"
                >
                    <div [ngSwitch]="ctx.type">
                        <div
                            class="yourteam-header--cell"
                            *ngSwitchCase="_YourTeamGridColumnId.USER_NAME"
                        >
                            {{ _i18n._102_USER_NAME | translate }}
                        </div>
                        <div
                            class="yourteam-header--cell"
                            *ngSwitchCase="_YourTeamGridColumnId.SUPER_GROUP"
                        >
                            {{ _i18n._67_SUPERGROUP | translate }}
                        </div>
                        <div
                            class="yourteam-header--cell"
                            *ngSwitchCase="_YourTeamGridColumnId.PERIOD"
                        >
                            {{ _i18n._773_PERIOD | translate }}
                        </div>
                        <div
                            class="yourteam-header--cell"
                            *ngSwitchCase="_YourTeamGridColumnId.OVERALL_SCORE"
                        >
                            {{ _i18n._962_OVERALL_SCORE | translate }}
                        </div>
                    </div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="row"
                    data-id="content"
                >
                    <div class="yourteam-body--row"></div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="cell"
                    data-id="content"
                    let-c="c"
                    let-ctx="ctx"
                >
                    <div [ngSwitch]="c.ctx.type">
                        <div
                            class="yourteam-body--row-cell"
                            *ngSwitchCase="_YourTeamGridColumnId.USER_NAME"
                        >
                            <button
                                class="cmps-button--no-bg yourteam-user-button"
                                cmpsButton
                                (click)="
                                    _onUserClick(
                                        ctx.data?.subordinateUserId,
                                        ctx.data?.subordinateScorecardId
                                    )
                                "
                            >
                                {{ ctx.data?.subordinateUserName }}
                            </button>
                        </div>
                        <div
                            class="yourteam-body--row-cell"
                            *ngSwitchCase="_YourTeamGridColumnId.SUPER_GROUP"
                        >
                            {{ ctx.data?.subordinateSuperGroupName }}
                        </div>
                        <div
                            class="yourteam-body--row-cell"
                            *ngSwitchCase="_YourTeamGridColumnId.PERIOD"
                        >
                            {{
                                ctx.data?.subordinateStartDate
                                    | cmpsDate: 'MM-dd-y'
                            }}
                            /
                            {{
                                ctx.data?.subordinateEndDate
                                    | cmpsDate: 'MM-dd-y'
                            }}
                        </div>
                        <div
                            class="yourteam-body--row-cell"
                            *ngSwitchCase="_YourTeamGridColumnId.OVERALL_SCORE"
                        >
                            {{
                                (ctx.data?.subordinateOverallScore
                                    | cmpsNumber: '1.0-2') || '-'
                            }}
                        </div>
                    </div>
                </ng-template>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
